import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import TeamCell from '../common/TeamCell';

export default function TeamStats({
  showBranding = false,
  competitionLabel = 'Premier League',
  teamStats = [],
}) {
  return (
    <div style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
      <div
        className="px-4 py-2 text-xs font-bold uppercase tracking-wide border-b"
        style={{ borderColor: 'var(--sw-border)', color: 'var(--sw-muted)' }}
      >
        {competitionLabel} — Goals for / against
      </div>
      <div className="p-3">
        {teamStats.length ? (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase" style={{ color: 'var(--sw-muted)' }}>
                <th className="p-2 w-8">#</th>
                <th className="p-2">Team</th>
                <th className="p-2 text-right w-10">GF</th>
                <th className="p-2 text-right w-10">GA</th>
                <th className="p-2 text-right w-10">GD</th>
              </tr>
            </thead>
            <tbody>
              {teamStats.map((r) => (
                <tr
                  key={`${r.position}-${r.team}`}
                  style={{ borderTop: '1px solid var(--sw-border)' }}
                >
                  <td className="p-2 font-mono text-xs">{r.position}</td>
                  <td className="p-2 font-medium">
                    <TeamCell row={r} />
                  </td>
                  <td className="p-2 text-right font-bold tabular-nums">{r.gf}</td>
                  <td className="p-2 text-right tabular-nums">{r.ga}</td>
                  <td className="p-2 text-right tabular-nums">{r.gd}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-center text-xs py-6" style={{ color: 'var(--sw-muted)' }}>
            Goals for/against not available for this table.
          </p>
        )}
      </div>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
